export const DOMAINS = {
  us: "archdaily.com",
  cl: "archdaily.cl",
  pe: "archdaily.pe",
  co: "archdaily.co",
  br: "archdaily.com.br",
  mx: "archdaily.mx",
  cn: "archdaily.cn"
};

export const RECOMMENDATION_ENTITIES_PATH = "/api/v1/users/recommendations/entities";
export const NOTIFICATION_FOLLOWING_PATH = "/following/";

export const ADPLUS_PLANS = ["premium", "student", "professional", "archive", "plus"];

export const TRACKING_AUDIO = {
  plays: {
    category: "adplus-audio",
    action: "1801,adplus-audio,click",
    label: "Play"
  },
  featuredPlays: {
    category: "audio-featured",
    action: "1803,adplus-audio,click",
    label: "featured-plays",
  },
  playlist: {
    category: "adplus-audio",
    action: "1802,adplus-audio,click",
    label: "playlist-link"
  }
};

export const TRACKING_BENEFITS = {
  reveal: {
    category: "adplus-benefits",
    action: "1701,benefits,click",
    label: "benefit-reveal"
  },
  link: {
    category: "adplus-benefits",
    action: "1702,benefits,click",
    label: "benefit-link"
  },
  discount: {
    category: "adplus-benefits",
    action: "1703,benefits,click",
    label: "copy-code"
  }
};

export const TRACKING_MAPS = {
  category: "adplus-maps",
  action: "1901,adplus-map,click",
  label: "map-link"
};
